import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CheckItem } from './CheckItem';
export function HeroSection() {
  return <section className="relative min-h-screen w-full bg-navy-darkest overflow-hidden" data-id="element-78">
      {/* Subtle radial gradient background */}
      <div className="absolute inset-0 opacity-40" style={{
      background: 'radial-gradient(ellipse at 70% 30%, rgba(26, 39, 68, 0.8) 0%, transparent 60%)'
    }} data-id="element-79" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-80">
        {/* Copy */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-81">
          <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-cream leading-tight mb-4" data-id="element-82">
            Si te despiertas entre las 2:00 y 3:00 AM
            <br data-id="element-83" />
            <span className="text-amber" data-id="element-84">con la mente acelerada…</span>
          </h1>

          <p className="font-playfair text-2xl md:text-3xl italic text-amber mb-6" data-id="element-85">
            No es casualidad. Y no es insomnio.
          </p>

          <p className="text-xl md:text-2xl text-cream font-light mb-8" data-id="element-86">
            Es tu cuerpo en vigilancia nocturna.
          </p>

          <p className="text-cream-muted text-lg leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-87">
            El Método de 21 Noches es un sistema guiado donde cada día sabes
            exactamente qué hacer antes de dormir y qué hacer si despiertas a
            las 2–3 AM.
          </p>

          <div className="flex flex-col items-center mb-10" data-id="element-88">
            <CTAButton className="w-full sm:w-auto" data-id="element-89">
              QUIERO EMPEZAR MI PROCESO DE 21 NOCHES
            </CTAButton>

            <p className="mt-4 text-cream-muted text-sm" data-id="element-90">
              Acceso inmediato en PDF descargable.
            </p>
          </div>

          <div className="space-y-4 mb-10 inline-block text-left" data-id="element-91">
            <CheckItem delay={0.1} data-id="element-92">
              Entiende qué activa tu mente en la madrugada
            </CheckItem>
            <CheckItem delay={0.2} data-id="element-93">
              Aprende qué hacer exactamente cuando despiertas a las 2:37 AM
            </CheckItem>
            <CheckItem delay={0.3} data-id="element-94">Baja tu cortisol antes de dormir</CheckItem>
            <CheckItem delay={0.4} data-id="element-95">
              Método práctico, claro y aplicable desde hoy
            </CheckItem>
          </div>

          {/* Product mockup below bullets */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="mt-10 flex justify-center" data-id="element-96">
            <img src="https://cdn.magicpatterns.com/uploads/rNSfD331Xdw6MhNw7gJo5N/EL_METODO_DE_21_NOCHES_(1).png" alt="Método de 21 Noches — vista completa del producto" className="w-full max-w-lg lg:max-w-xl object-contain drop-shadow-2xl" data-id="element-97" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}